import { makeAutoObservable } from 'mobx'
import NewPaginationStore from '../../../stores/NewPaginationStore'
import { singleMaintenanceReportPaginationStore } from '../../SingleServiceReport/hooks/useSingleServiceReportTableData'
import { customersPaginationStore } from '../hooks/useCustomerTableData'

class SinglePageSwitcherStore<T extends Object> {
  allIds: number[] = []
  currIdx: number | null = null
  prevId: number | null = null
  nextId: number | null = null
  backRoute: string | null = null
  paginationStore: NewPaginationStore<T> | null = null

  constructor(paginationStore?: NewPaginationStore<T>) {
    this.paginationStore = paginationStore ?? null

    makeAutoObservable(this)
  }

  setPaginationStore = (paginationStore: NewPaginationStore<T>) => {
    this.paginationStore = paginationStore
  }

  setAllIds = (ids: number[]) => {
    this.allIds = ids
  }

  setCurrId = (id: number) => {
    this.currIdx = this.allIds.findIndex((el) => el === id)
    this.prevId = this.allIds[this.currIdx - 1]
    this.nextId = this.allIds[this.currIdx + 1]
  }

  goPrev = () => {
    if (this.backRoute?.includes('service-reports')) {
      singleMaintenanceReportPaginationStore.setSelectedRow(
        { id: this.allIds[this.currIdx! - 1] },
        singleMaintenanceReportPaginationStore.scrollHeight - 56,
      )
    } else {
      this.paginationStore?.setSelectedRow(
        { id: this.allIds[this.currIdx! - 1] },
        this.paginationStore?.scrollHeight - 56,
      )
    }
    this.currIdx = this.currIdx! - 1
    this.prevId = this.allIds[this.currIdx - 1]
    this.nextId = this.allIds[this.currIdx + 1]
  }

  goNext = () => {
    if (this.backRoute?.includes('service-reports')) {
      singleMaintenanceReportPaginationStore.setSelectedRow(
        { id: this.allIds[this.currIdx! + 1] },
        singleMaintenanceReportPaginationStore.scrollHeight + 56,
      )
    } else {
      this.paginationStore?.setSelectedRow(
        { id: this.allIds[this.currIdx! + 1] },
        this.paginationStore?.scrollHeight + 56,
      )
    }

    if (this.allIds.length > this.currIdx! + 1) {
      this.currIdx = this.currIdx! + 1
      this.prevId = this.allIds[this.currIdx - 1]
      this.nextId = this.allIds[this.currIdx + 1]
    }
  }

  setBackRoute = (route: string) => {
    this.backRoute = route
  }

  clear = () => {
    this.prevId = null
    this.currIdx = null
    this.nextId = null
    this.allIds = []
  }
}

export const customersStore = new SinglePageSwitcherStore(
  customersPaginationStore,
)

export type PageSwitcherStoreType<
  T extends Record<string, any> = Record<string, any>,
> = InstanceType<typeof SinglePageSwitcherStore<T>>

export default SinglePageSwitcherStore
